/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbVisiteClasseGridDto } from './FcbVisiteClasseGridDto';
import {
    FcbVisiteClasseGridDtoFromJSON,
    FcbVisiteClasseGridDtoFromJSONTyped,
    FcbVisiteClasseGridDtoToJSON,
} from './FcbVisiteClasseGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbVisiteClasseGridDtoPaginatedResults
 */
export interface FcbVisiteClasseGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbVisiteClasseGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbVisiteClasseGridDto>}
     * @memberof FcbVisiteClasseGridDtoPaginatedResults
     */
    results?: Array<FcbVisiteClasseGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbVisiteClasseGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbVisiteClasseGridDtoPaginatedResults interface.
 */
export function instanceOfFcbVisiteClasseGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbVisiteClasseGridDtoPaginatedResultsFromJSON(json: any): FcbVisiteClasseGridDtoPaginatedResults {
    return FcbVisiteClasseGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbVisiteClasseGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbVisiteClasseGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbVisiteClasseGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbVisiteClasseGridDtoPaginatedResultsToJSON(value?: FcbVisiteClasseGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbVisiteClasseGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

